import { constants } from '@bedc/constants';

import { Request as BaseRequest } from '../../generic/search/Request';

export const Request = BaseRequest({
	sortFields: constants.user.search.estimatorSortFields,
	columnFields: constants.user.search.columnFields,
	standardFilterFields: constants.user.search.standardFilterFields,
	dateFilterFields: [] as const,
	stageStatusFilterFields: [] as const,
	booleanFilterFields: constants.user.search.booleanFilterFields,
});
